const en = {
  addManager: 'Add a manager',
  lastName: {
    placeholder: 'e.g. Name',
    errorMessage: 'Last name is required',
    label: 'Last Name',
  },
  firstName: {
    placeholder: 'e.g. Thomas',
    errorMessage: 'First name is required',
    label: 'First Name',
  },
  phone: {
    placeholder: '01 28 43 26 69',
    errorMessage: 'Phone number is required and must contain only 10 digits',
    label: 'Phone',
  },
  email: {
    placeholder: 'name@domain.com',
    errorMessage: 'Please enter a valid email address',
    label: 'Email',
  },
  role: {
    errorMessage: 'Role is required',
    label: 'Role',
    selectOptions: {
      worker: 'Contributor',
      candidate: 'Candidate',
      manager: 'Manager',
      admin: 'Admin',
    },
  },
};

export default en;
export type Translations = typeof en;
